'use client';

import { cn } from '@/lib/utils';
import MarketSection from './MarketSection';
import useWorldCupGamelines from '../../hooks/use-world-cup-gamelines';
import { buildColumns, buildMarketSection } from './marketTableUtils';

export interface GamelinePanelProps {
  eventSlug: string;
  className?: string;
}

export default function GamelinePanel({ eventSlug, className }: GamelinePanelProps) {
  const { gamelines } = useWorldCupGamelines({ eventSlug });
  const columns = buildColumns();
  const sections = gamelines
    ? [
        buildMarketSection('Moneyline', gamelines.moneyline, {
          icon_name: 'winner',
          icon_class_name: 'text-[#F5BA80]',
          tooltip: 'Moneyline shows the predicted final match result: home win, draw, or away win.',
        }),
        buildMarketSection('Spreads', gamelines.spreads, {
          icon_name: 'spreads',
          icon_class_name: 'text-[#12B3CF]',
          tooltip:
            'Spreads use a goal handicap. The selected team must beat the handicap for the prediction to succeed.',
        }),
        buildMarketSection('Totals', gamelines.totals, {
          icon_name: 'totals',
          icon_class_name: 'text-[#6288FF]',
          tooltip:
            'Totals predict whether the combined goals from both teams will be over or under a set number.',
        }),
        buildMarketSection('Both Teams to Score', gamelines.both_teams_to_score, {
          icon_name: 'winner',
          icon_class_name: 'text-[#6288FF]',
          tooltip: 'Predict whether both teams will score at least one goal in the match.',
        }),
      ].filter((section) => section.rows.length > 0)
    : [];

  return (
    <section
      className={cn('w-full text-white', className)}
      style={{ fontFamily: "'SF Pro', -apple-system, BlinkMacSystemFont, sans-serif" }}
    >
      <div className="space-y-2 overflow-x-auto pb-1">
        <div className="min-w-180 space-y-2">
          {sections.map((section) => (
            <MarketSection key={section.title} section={section} columns={columns} />
          ))}
        </div>
      </div>
    </section>
  );
}
